import {entroHttpClient} from '../../'

const apiBaseUrl = window.ENTRO_AUTH_URI;
const userInfoPath = '/api/user-info';

function getUserInfo() {
  return entroHttpClient.get(`${apiBaseUrl}${userInfoPath}`);
}

export default {
  getUserInfo
}
